import ArrayUtils from '@/utils/arrayUtils'

export default
{
    namespaced: true,
    
    state:
    {
        eventList: []
    },

    getters:
    {
        getEventById: state => id =>
        {
            return state.eventList.find(e => e.id == id)
        }
    },

    mutations:
    {
        setEventList (state, events)
        {
            state.eventList = events
        },

        updateEventList (state, events) 
        {
            var merged = ArrayUtils.mergeArrays(state.eventList, events, (a, b) => a.id == b.id)
            
            merged = merged.sort((a, b) =>
            {
                if (a.isUncreated) return -Infinity

                let dDate = new Date(b.date) - new Date(a.date)
                let dId = b.id - a.id

                return dDate + dId
            })

            state.eventList = merged
        }
    },

    actions:
    {
        removeEventById ({ getters, state }, id)
        {
            let event = getters.getEventById(id)
            
            if (!event) return
            
            const events = state.eventList
            events.splice(events.indexOf(event), 1)

            state.eventList = events
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/events.js